module.exports = __webpack_public_path__ + "static/new-machine-policy-template-ee1d01d55b6bce6aef80954512cfb6cf.png";